import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EMPTY_STRING, inventoryConstants } from "../../../constants";
import { getDisplayProductTags } from "../../utility";

const TitleToolTip = ({
  title = EMPTY_STRING, // title is what shown in the tooltip menu
  children, // children is what is shown in the component (like span, div, etc) and when hovered then tooltip will be shown
  placement = "bottom",
  isWrapChildren = false,
  childrenClassName = EMPTY_STRING,
}) => {
  const id = `${Math.random() * 10}-${title}`;
  let toolTipTitle = title;
  // if title is an array (sku, tag) then convert into jsx
  if (Array.isArray(title) && title.length) {
    toolTipTitle = (
      <>
        {getDisplayProductTags(title).map((s, index) => (
          <p
            className="sku-wrapper text-nowrap text-start fw-normal m-0"
            key={index}
          >
            {s}
          </p>
        ))}
      </>
    );
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id} className="title-tooltip">
          {toolTipTitle}
        </Tooltip>
      }
    >
      {
        // if children is string then wrap in span with truncate (NewReturn => product name), if isWrapChildren is true then wrap in div with truncate (Items.jsx => getProductNameColumn), else just show children
        typeof children === "string" ? (
          <span className={`text-truncate ${childrenClassName}`}>
            {children}
          </span>
        ) : isWrapChildren ? (
          <div className={`text-truncate ${childrenClassName}`}>
            <span>{children}</span>
          </div>
        ) : (
          <>{children}</>
        )
      }
    </OverlayTrigger>
  );
};

export default TitleToolTip;
